import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LandingLayout } from '@/components/Layouts'
import { Home } from '../home'
import { Offers } from '../offers'

export const LandingRoot = () => {
  return (
    <Routes>
      <Route element={<LandingLayout />}>
        <Route index element={<Home />} />
        <Route path={'offers'} element={<Offers />} />
      </Route>

      <Route path={'*'} element={<Navigate to={'/'} replace={true} />} />
    </Routes>
  )
}
